module.exports = __webpack_public_path__ + "img/bg_4.521c68bd.png";